import React, { useState, useEffect } from 'react';
import { Button, Input, Alert } from '@kubed/components';
import './App.css';
import { useTranslation } from 'react-i18next';
import './i18n';
import i18n from './i18n';

function App() {
  const { t } = useTranslation();
  const [coreVersion, setCoreVersion] = useState("Loading...");
  const [chartVersion, setChartVersion] = useState("Loading...");
  const [extensionsMuseumVersion, setExtensionsMuseumVersion] = useState("Loading...");
  const [extensionsVersion, setExtensionsVersion] = useState("Loading...");
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [extensions, setExtensions] = useState([]);
  const [submissionStatus, setSubmissionStatus] = useState('default');
  const [selectedExtensions, setSelectedExtensions] = useState(new Set());
  const [isValidEmail, setIsValidEmail] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/v1alpha1/release');
        if (!response.ok) {
          throw new Error('Failed to fetch config');
        }
        const data = await response.json();

        let extensions = []
        extensions = data.extensions.map(ext => ({
          name: ext.name,
          displayName: ext.displayName,
          version: ext.version,
          description: ext.description,
          icon: ext.icon === "" ? '/logo/ks-logo.png' : "/extensions/ks-extensions-" + data.extensionsVersion.replace(/^v/, '') + '/' + ext.name + ext.icon.replace(/^\./, ''),
          checked: false,
          tags: [ext.category]
        }));
        setCoreVersion(data.coreVersion);
        setChartVersion(data.chartVersion);
        setExtensionsMuseumVersion(data.extensionsVersion);
        setExtensionsVersion(data.extensionsVersion);
        setExtensions(extensions);
      } catch (error) {
        setMessage(`Error: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  const handleExtensionClick = (name) => {
    setSelectedExtensions(prevSelected => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(name)) {
        newSelected.delete(name);
      } else {
        newSelected.add(name);
      }
      return newSelected;
    });
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedExtensions(new Set(extensions.map(ext => ext.name)));
    } else {
      setSelectedExtensions(new Set());
    }
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setEmail(email);
    setIsValidEmail(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
  };

  const handleSubmit = async () => {
    const data = {
      coreVersion: coreVersion,
      chartVersion: chartVersion,
      extensionsVersion: extensionsVersion,
      email: email,
      extensions: Array.from(selectedExtensions)
    };
    try {
      const response = await fetch('/api/v1alpha1/images', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Failed to get images');
      }

      setMessage(t('success_message'));
      setSubmissionStatus('info');
    } catch (error) {
      setMessage(t('error_message'));
      setSubmissionStatus('error');
    }
  };


  return (
    <div className="container">
      <h2>{t('title')}</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div class="version-info">
            <div class="version-item">
               <span class="version-label">{t('latest_core_version')}:</span>
               <span>{coreVersion}</span>
            </div>
            <div class="version-item">
              <span class="version-label">{t('latest_chat_version')}:</span>
              <span>{chartVersion}</span>
            </div>
            <div className="version-item">
              <span className="version-label">{t('latest_extensions_museum_version')}:</span>
              <span>{extensionsMuseumVersion}</span>
            </div>
          </div>

          <div class="extensions-container">
            <div class="extensions-header">
                <h3>{t('select_extensions')}</h3>
                <label className="select-all">
                   <input
                     type="checkbox"
                     id="selectAll"
                     checked={selectedExtensions.size === extensions.length}
                     onChange={handleSelectAllChange}
                   />
                   全选
                </label>
            </div>

            <div class="extensions-grid" id="extensionsGrid">
              {extensions.map(ext => (
              <div
                key={ext.name}
                className={`extension-card ${selectedExtensions.has(ext.name) ? 'selected' : ''}`}
                onClick={() => handleExtensionClick(ext.name)}
              >
                <div className="extension-logo">
                  <div className='tooltip'>{ext.description[i18n.language.startsWith('zh')? 'zh' : 'en']}</div>
                  <img src={ext.icon} alt='Extension Icon'/>
                </div>
                <div className="extension-info">
                  <div className="extension-name">{ext.displayName[i18n.language.startsWith('zh')? 'zh' : 'en']}</div>
                  <div className="extension-tags">
                      {ext.tags.map((tag, index) => (
                        <span key={index} className="extension-tag">{tag}</span>
                      ))}
                  </div>
                  <div className="extension-desc" style={{display: 'none'}}>
                    {ext.description[i18n.language.startsWith('zh')? 'zh' : 'en']}
                  </div>
                </div>
              </div>

              ))}
            </div>
          </div>
          <div className="email-section">
              <h5>{t('email')}</h5>
              <Input
                className="email-input"
                value={email}
                onChange={handleEmailChange}
                placeholder={t('email_placeholder')}
              />
              <Button
                className="submit-btn"
                radius={0}
                onClick={handleSubmit}
                disabled={!isValidEmail || selectedExtensions.size === 0 || submissionStatus === 'info'}
              >
                {t('get_image_list_button')}
              </Button>
              <Alert
                style={{ marginTop: '20px', display: message ? 'block' : 'none' }}
                title={message}
                type={submissionStatus}
                showIcon
              />
          </div>
        </>
      )}
    </div>
  );
}


export default App;
